export default {
  getShop: (state) => state.shop,
};
